<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 09:52:04
 * @LastEditTime: 2020-06-21 16:39:23
 * @Description: 多选题
 -->
<template>
  <div class="multiple">
    <div class="title">
      <span>{{ title }}</span>
      <div
        v-if="stemMediaInfoVO.mediaPath"
        class="look-media"
        @click="lookMedia(stemMediaInfoVO)">查看多媒体</div>
    </div>
    <i-checkbox-group :value="userAnswer" size="small">
      <i-checkbox
        v-for="(option, index) in options"
        :key="index"
        :label="option.id" disabled>
        <span
          class="option-content">
          {{ `${optionsMap[index]}、${option.content ? option.content : ''}` }}</span>
        <div
          v-if="option.mediaInfoVO && option.mediaInfoVO.mediaPath"
          class="look-media"
          @click="lookMedia(option.mediaInfoVO)">查看多媒体</div>
      </i-checkbox>
    </i-checkbox-group>
    <div class="analysis">
      <div class="analysis-left">
        <p>学员答案：{{ userCorrectAnswer }}</p>
        <p>正确答案：{{ correctAnswer }}</p>
        <p>解析说明：{{ tip !== undefined ? tip : '无' }}</p>
      </div>
      <div class="analysis-right" v-if="status === '已统分'">
        <div :class="[correct ? 'correct' : 'error']">
          {{ correct ? '正确' : '错误' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const optionsMap = ['A', 'B', 'C', 'D', 'E', 'F'];

export default {
  name: 'MultipleChoice',
  props: {
    status: { type: String, required: true },
    index: { type: Number, required: true },
    question: { type: Object, required: true },
  },
  data() {
    return {
      optionsMap,
      correctAnswer: '',
      userAnswer: [],
      userCorrectAnswer: [],
    };
  },
  computed: {
    title() {
      return `${this.index + 1}、${this.question.content}（${this.question.totalScore}分）`;
    },
    options() {
      return this.question.options;
    },
    correct() {
      return this.question.correct;
    },
    counted() {
      return this.correct !== undefined;
    },
    tip() {
      return this.question.tip;
    },
    stemMediaInfoVO() {
      return this.question.mediaInfoVO ? this.question.mediaInfoVO : {};
    },
  },
  watch: {
    question: {
      immediate: true,
      handler(question) {
        const correctAnswer = [];
        if (question.userAnswer) {
          this.userAnswer = question.userAnswer.split(']');
        }

        if (!(question.options instanceof Array)) {
          question.options = [];
        }

        question.options.forEach((option, index) => {
          if (option.correct) {
            correctAnswer.push(this.optionsMap[index]);
          }
          this.userAnswer.forEach((val) => {
            if (val === option.id) {
              this.userCorrectAnswer.push(this.optionsMap[index]);
            }
          });
        });

        this.correctAnswer = correctAnswer.join('、');
        this.userCorrectAnswer = this.userCorrectAnswer.join('、');
      },
    },
  },
  methods: {
    lookMedia({ mediaContentType, mediaPath, videoCover }) {
      this.$emit('preview-media', { mediaContentType, mediaPath, videoCover });
    },
  },
};
</script>

<style lang="less" scoped>
.multiple {
  width: 100%;

  > .title {
    margin-bottom: 8px;
  }

  /deep/ .ivu-checkbox-group {
    display: flex;
    flex-direction: column;

    > .ivu-checkbox-group-item {
      display: flex;
      align-items: center;
      height: 30px;
      font-size: 12px;

      > .ivu-checkbox {
        margin-right: 8px;

        &.ivu-checkbox-disabled {
          + span {
            color: @font-primary-color;
          }
        }

        &.ivu-checkbox-checked {
          .ivu-checkbox-inner {
            border-color: #2d8cf0 !important;
            background-color: #2d8cf0 !important;

            &::after {
              border-color: #fff;
            }
          }
        }
      }
    }
  }

  > .analysis {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    background-color: #fbf9fb;

    > .analysis-left {
      > p {
        line-height: 26px;
      }
    }

    > .analysis-right {
      display: flex;
      align-items: center;
      >.error{
        width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #ed4014;
      }
      >.correct{
        width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #2d8cf0;
      }
    }
  }

  .option-content {
    margin-right: 16px;
  }

  .look-media {
    display: inline-block;
    color: #0C8CCA;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
    background-color: rgba(12, 140, 202, .1);
    border-radius: 6px;
    line-height: normal;
  }
}
</style>
